// Wedding vendor categories
export const VENDOR_CATEGORIES = {
  DJ: 'dj',
  DHOL: 'dhol',
  MAKEUP: 'makeup',
  HENNA: 'henna',
  CATERING: 'catering',
  VENUES: 'venues',
  DECOR: 'decor',
  MANDAP: 'mandap',
  PHOTOGRAPHY: 'photography',
  VIDEOGRAPHY: 'videography',
  PLANNING: 'planning',
  MEHNDI: 'mehndi',
  PRIEST: 'priest',
  MUSICIANS: 'musicians',
  RANGOLI: 'rangoli',
  FLORIST: 'florist',
  TRANSPORTATION: 'transportation',
  INVITATIONS: 'invitations',
  JEWELRY: 'jewelry',
  ATTIRE: 'attire'
};

// Wedding cultures and traditions
export const WEDDING_CULTURES = {
  PUNJABI: 'punjabi',
  HINDU: 'hindu',
  SIKH: 'sikh',
  MUSLIM: 'muslim',
  GUJARATI: 'gujarati',
  TAMIL: 'tamil',
  BENGALI: 'bengali',
  SOUTH_INDIAN: 'south_indian',
  MARATHI: 'marathi',
  TELUGU: 'telugu',
  MALAYALAM: 'malayalam',
  KANNADA: 'kannada',
  FUSION: 'fusion',
  CHRISTIAN: 'christian',
  JAIN: 'jain',
  PARSI: 'parsi'
};

// Budget tiers
export const BUDGET_TIERS = {
  BUDGET: 'budget',
  MID_RANGE: 'mid_range',
  PREMIUM: 'premium',
  LUXURY: 'luxury'
};

// Vendor tags
export const VENDOR_TAGS = {
  VERIFIED: 'verified',
  FEMALE_OWNED: 'female_owned',
  OFFERS_TRIAL: 'offers_trial',
  TRAVEL_AVAILABLE: 'travel_available',
  SAME_DAY_BOOKING: 'same_day_booking',
  MULTILINGUAL: 'multilingual',
  AWARD_WINNING: 'award_winning',
  NEW_VENDOR: 'new_vendor',
  POPULAR: 'popular',
  TRENDING: 'trending'
};

// US States
export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

// Major cities for South Asian communities
export const MAJOR_CITIES = [
  'New York, NY',
  'Los Angeles, CA',
  'Chicago, IL',
  'Houston, TX',
  'Phoenix, AZ',
  'Philadelphia, PA',
  'San Antonio, TX',
  'San Diego, CA',
  'Dallas, TX',
  'San Jose, CA',
  'Austin, TX',
  'Jacksonville, FL',
  'Fort Worth, TX',
  'Columbus, OH',
  'Charlotte, NC',
  'San Francisco, CA',
  'Indianapolis, IN',
  'Seattle, WA',
  'Denver, CO',
  'Washington, DC',
  'Boston, MA',
  'Atlanta, GA',
  'Nashville, TN',
  'Detroit, MI',
  'Portland, OR',
  'Las Vegas, NV',
  'Memphis, TN',
  'Louisville, KY',
  'Baltimore, MD',
  'Milwaukee, WI',
  'Albuquerque, NM',
  'Tucson, AZ',
  'Fresno, CA',
  'Sacramento, CA',
  'Mesa, AZ',
  'Kansas City, MO',
  'Omaha, NE',
  'Cleveland, OH',
  'Virginia Beach, VA',
  'Miami, FL',
  'Tampa, FL',
  'Orlando, FL',
  'Minneapolis, MN',
  'Raleigh, NC',
  'New Orleans, LA',
  'Wichita, KS',
  'Bakersfield, CA',
  'Aurora, CO',
  'Anaheim, CA',
  'Honolulu, HI',
  'Santa Ana, CA',
  'Riverside, CA',
  'Corpus Christi, TX',
  'Lexington, KY',
  'Stockton, CA',
  'Henderson, NV',
  'Saint Paul, MN',
  'St. Louis, MO',
  'Cincinnati, OH',
  'Pittsburgh, PA',
  'Greensboro, NC',
  'Anchorage, AK',
  'Plano, TX',
  'Lincoln, NE',
  'Jersey City, NJ',
  'Buffalo, NY',
  'Chandler, AZ',
  'Chula Vista, CA',
  'Norfolk, VA',
  'Newark, NJ',
  'North Las Vegas, NV',
  'Gilbert, AZ',
  'Lubbock, TX',
  'Reno, NV',
  'Winston-Salem, NC',
  'Glendale, AZ',
  'Hialeah, FL',
  'Garland, TX',
  'Scottsdale, AZ',
  'Laredo, TX',
  'Chesapeake, VA',
  'Baton Rouge, LA',
  'Fremont, CA',
  'Richmond, VA',
  'Boise, ID',
  'San Bernardino, CA',
  'Birmingham, AL',
  'Spokane, WA',
  'Rochester, NY',
  'Des Moines, IA',
  'Modesto, CA',
  'Fayetteville, NC',
  'Tacoma, WA',
  'Oxnard, CA',
  'Fontana, CA',
  'Columbus, GA',
  'Montgomery, AL',
  'Moreno Valley, CA',
  'Shreveport, LA',
  'Aurora, IL',
  'Yonkers, NY',
  'Akron, OH',
  'Huntington Beach, CA',
  'Little Rock, AR',
  'Augusta, GA',
  'Amarillo, TX',
  'Glendale, CA',
  'Mobile, AL',
  'Grand Rapids, MI',
  'Salt Lake City, UT',
  'Tallahassee, FL',
  'Huntsville, AL',
  'Grand Prairie, TX',
  'Knoxville, TN',
  'Worcester, MA',
  'Newport News, VA',
  'Brownsville, TX',
  'Santa Clarita, CA',
  'Providence, RI',
  'Fort Lauderdale, FL',
  'Chattanooga, TN',
  'Oceanside, CA',
  'Garden Grove, CA',
  'Rancho Cucamonga, CA'
];

// Languages commonly spoken in South Asian communities
export const LANGUAGES = [
  'English',
  'Hindi',
  'Punjabi',
  'Gujarati',
  'Tamil',
  'Telugu',
  'Bengali',
  'Marathi',
  'Kannada',
  'Malayalam',
  'Urdu',
  'Nepali',
  'Sinhalese',
  'Oriya',
  'Assamese'
];

// Wedding planning timeline
export const WEDDING_TIMELINE = {
  '12_MONTHS': '12+ months before',
  '9_MONTHS': '9-11 months before',
  '6_MONTHS': '6-8 months before',
  '3_MONTHS': '3-5 months before',
  '1_MONTH': '1-2 months before',
  '2_WEEKS': '2 weeks before',
  '1_WEEK': '1 week before',
  'WEDDING_DAY': 'Wedding day'
};

// API endpoints
export const API_ENDPOINTS = {
  VENDORS: '/api/vendors',
  SEARCH: '/api/search',
  CATEGORIES: '/api/categories',
  INQUIRIES: '/api/inquiries',
  REVIEWS: '/api/reviews',
  BOOKINGS: '/api/bookings',
  USERS: '/api/users',
  CHAT: '/api/chat',
  UPLOAD: '/api/upload',
  ANALYTICS: '/api/analytics'
};

// Form validation rules
export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\+]?[1-9][\d]{0,15}$/,
  ZIP_CODE: /^\d{5}(-\d{4})?$/,
  WEBSITE: /^https?:\/\/.+/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/
};

// Default values
export const DEFAULT_VALUES = {
  RESULTS_PER_PAGE: 12,
  SEARCH_RADIUS: 50,
  CAROUSEL_ITEMS: 4,
  MAX_UPLOAD_SIZE: 5 * 1024 * 1024, // 5MB
  DEBOUNCE_DELAY: 300,
  ANIMATION_DURATION: 200
};

// Error messages
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  INVALID_PHONE: 'Please enter a valid phone number',
  INVALID_ZIP: 'Please enter a valid ZIP code',
  INVALID_WEBSITE: 'Please enter a valid website URL',
  WEAK_PASSWORD: 'Password must be at least 8 characters with uppercase, lowercase, and numbers',
  UPLOAD_TOO_LARGE: 'File size must be less than 5MB',
  UPLOAD_INVALID_TYPE: 'Please upload a valid image file',
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  UNAUTHORIZED: 'You are not authorized to perform this action',
  SERVER_ERROR: 'Server error. Please try again later.',
  NOT_FOUND: 'The requested resource was not found'
};

// Success messages
export const SUCCESS_MESSAGES = {
  VENDOR_REGISTERED: 'Vendor registration successful! We will review your application within 24 hours.',
  INQUIRY_SENT: 'Your inquiry has been sent successfully. The vendor will respond within 24 hours.',
  PROFILE_UPDATED: 'Your profile has been updated successfully.',
  REVIEW_SUBMITTED: 'Thank you for your review! It will be published after moderation.',
  BOOKING_CONFIRMED: 'Your booking has been confirmed. You will receive a confirmation email shortly.',
  PASSWORD_RESET: 'Password reset link has been sent to your email address.'
};

// Feature flags
export const FEATURE_FLAGS = {
  AI_SEARCH: true,
  CHATBOT: true,
  REAL_TIME_CHAT: true,
  PAYMENT_INTEGRATION: true,
  ANALYTICS: true,
  PUSH_NOTIFICATIONS: true,
  ADVANCED_FILTERING: true,
  SOCIAL_LOGIN: true,
  VENDOR_VERIFICATION: true,
  REVIEW_SYSTEM: true
};

export default {
  VENDOR_CATEGORIES,
  WEDDING_CULTURES,
  BUDGET_TIERS,
  VENDOR_TAGS,
  US_STATES,
  MAJOR_CITIES,
  LANGUAGES,
  WEDDING_TIMELINE,
  API_ENDPOINTS,
  VALIDATION_RULES,
  DEFAULT_VALUES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  FEATURE_FLAGS
};